import { hasFilledFields } from "../autosave/saveHelpers";
import type { BorrowerData } from "../types/applicationTypes";

export type SkippableOptionalSection = "assets" | "incomes" | "expenses";

type SectionItem = { serverId?: string };

function sectionHasPersistedOrFilledItems<T extends SectionItem>(
  items: T[],
): boolean {
  return items.some((item) => item.serverId || hasFilledFields(item));
}

/** True when the borrower has no saved or in-progress items for this section. */
export function shouldSkipOptionalSection(items: SectionItem[]): boolean {
  return !sectionHasPersistedOrFilledItems(items);
}

export function getEmptyOptionalSectionsToSkip(
  borrower: BorrowerData,
): SkippableOptionalSection[] {
  const sections: SkippableOptionalSection[] = [];
  if (shouldSkipOptionalSection(borrower.financialAccounts)) {
    sections.push("assets");
  }
  if (shouldSkipOptionalSection(borrower.additionalIncome)) {
    sections.push("incomes");
  }
  if (shouldSkipOptionalSection(borrower.expenses)) {
    sections.push("expenses");
  }
  return sections;
}
